var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"special-option-button"},[_c('SmartLink',{staticClass:"special-option-button__link",attrs:{"url":_vm.url,"route":_vm.route,"target":_vm.target,"method":_vm.method,"event":_vm.event}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }